<script setup lang="ts">
  import { defineProps, computed } from 'vue'
  import { linkifyText } from '@/utils/stringUtils'

  const props = defineProps({
    helpText: {
      type: String,
      default: ''
    }
  })

  const htmlContent = computed(() => linkifyText(props.helpText))
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span v-html="htmlContent"></span>
</template>
